import Scene from '../index.js'
import Particles from './Particles.js'
import Trail from './Trail.js'
/*  
*   Handles the intanciation of all visible elements in the scene 
*/ 

class World
{
    constructor()
    {
        this.scene = Scene.instance
        this.loader = Scene.loader
        this.clock = Scene.clock

        this.loader.on('ready', () =>
        {
            this.particles = new Particles({img: this.loader.items.img})
            this.trail = new Trail({ratio: this.particles.ratio})
            this.particles.trail = this.trail

        })

        this.clock.on('run', () => 
        {
            this.update()
        })
    } 

    update()
    {
        if(this.trail) this.trail.update()
    }

    setImage(img)
    {
        // Destroy old particles and trail
        if (this.particles)
        {
            this.scene.remove(this.particles.group)
            if (typeof this.particles.destroy === 'function')
            {
                this.particles.destroy()
            }
            this.particles = null
        }
        if (this.trail)
        {
            this.trail = null
        }

        // Create new ones
        this.particles = new Particles({img: img})
        this.trail = new Trail({ratio: this.particles.ratio})
        this.particles.trail = this.trail
    }
}

export default World